import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SetLastAccountLedgerProcessedConfigMutationVariables = Types.Exact<{
  input: Types.LastAccountLedgerProcessedConfigInput;
}>;


export type SetLastAccountLedgerProcessedConfigMutation = { __typename?: 'Mutation', setLastAccountLedgerProcessedConfig: { __typename?: 'LastAccountLedgerProcessedConfig', id: string, last_account_ledger_batch_number: string, last_account_ledger_processed_at: string, updated_at: string } };


export const SetLastAccountLedgerProcessedConfigDocument = gql`
    mutation SetLastAccountLedgerProcessedConfig($input: LastAccountLedgerProcessedConfigInput!) {
  setLastAccountLedgerProcessedConfig(input: $input) {
    id
    last_account_ledger_batch_number
    last_account_ledger_processed_at
    updated_at
  }
}
    `;
export type SetLastAccountLedgerProcessedConfigMutationFn = Apollo.MutationFunction<SetLastAccountLedgerProcessedConfigMutation, SetLastAccountLedgerProcessedConfigMutationVariables>;

/**
 * __useSetLastAccountLedgerProcessedConfigMutation__
 *
 * To run a mutation, you first call `useSetLastAccountLedgerProcessedConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetLastAccountLedgerProcessedConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setLastAccountLedgerProcessedConfigMutation, { data, loading, error }] = useSetLastAccountLedgerProcessedConfigMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetLastAccountLedgerProcessedConfigMutation(baseOptions?: Apollo.MutationHookOptions<SetLastAccountLedgerProcessedConfigMutation, SetLastAccountLedgerProcessedConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetLastAccountLedgerProcessedConfigMutation, SetLastAccountLedgerProcessedConfigMutationVariables>(SetLastAccountLedgerProcessedConfigDocument, options);
      }
export type SetLastAccountLedgerProcessedConfigMutationHookResult = ReturnType<typeof useSetLastAccountLedgerProcessedConfigMutation>;
export type SetLastAccountLedgerProcessedConfigMutationResult = Apollo.MutationResult<SetLastAccountLedgerProcessedConfigMutation>;
export type SetLastAccountLedgerProcessedConfigMutationOptions = Apollo.BaseMutationOptions<SetLastAccountLedgerProcessedConfigMutation, SetLastAccountLedgerProcessedConfigMutationVariables>;